import Page from '../components/Page';

const AnotherPage = () => {
  return (
    <Page title={'Giraf'}>
      <h1>END USER AnotherPage</h1>
    </Page>
  );
};

export default AnotherPage;
